import { DropdownOptionType } from "../types";

export function endYearValidation(
  startYear: DropdownOptionType,
  startMonth: DropdownOptionType,
  yearOptions: Array<DropdownOptionType>,
): Array<DropdownOptionType> {
  let newYearList: Array<DropdownOptionType> = [];
  for (const obj of yearOptions) {
    // if (startMonth.text === "December") {
    //   if (obj.text === startYear.text) {
    //     continue;
    //   }
    // }
    if (obj.text >= startYear.text) {
      newYearList.push(obj);
    } else {
      continue;
    }
  }
  return newYearList;
}

export function endMonthValidation(
  startYear: DropdownOptionType,
  startMonth: DropdownOptionType,
  endYear: DropdownOptionType,
  monthOptions: Array<DropdownOptionType>,
): Array<DropdownOptionType> {
  let newMonthList: Array<DropdownOptionType> = [];
  if (endYear.text !== new Date().getFullYear().toString()) {
    if (startYear?.text && startYear.text === endYear.text) {
      for (const obj of monthOptions) {
        if (obj.id >= startMonth.id) {
          newMonthList.push(obj);
        }
      }
    } else {
      return monthOptions;
    }
  } else {
    const currentMonth = new Date().getMonth();
    for (const obj of monthOptions) {
      if (
        startYear?.text &&
        startMonth.id &&
        startYear.text === endYear.text &&
        startMonth.id > obj.id
      ) {
        continue;
      }
      if (currentMonth < Number(obj.id)) {
        break;
      } else {
        newMonthList.push(obj);
      }
    }
  }

  return newMonthList;
}
